import React from 'react'
import Overview from 'components/insightContent/visualization/Overview'
import { InsightContentSettingType } from 'components/insightContent/types'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import useCrosstabData from 'components/widget/CrosstabWidgets/share/Crosstab/useCrosstabData'
import ComparisonMode from 'enums/ComparisonMode'
import Title from './Title'
import resolveSum from '../utils/sumResolver'

const AllTopicsTotalMeasure = ({
  detailSetting,
  widgetId,
  isAudienceQuery
}: {
  detailSetting: InsightContentSettingType
  widgetId: number
  isAudienceQuery: boolean
}) => {
  const { viewOption, rowComparisonMode } = detailSetting
  const { crossTabs } = useCrosstabData(widgetId, isAudienceQuery)

  return (
    <UnexpectedErrorBoundary>
      <Overview
        title={
          <Title
            viewOption={viewOption}
            isForAllTopics={rowComparisonMode === ComparisonMode.TOPICS}
          />
        }
        count={resolveSum(crossTabs)}
        status="succeeded"
      />
    </UnexpectedErrorBoundary>
  )
}

export default AllTopicsTotalMeasure
